import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';
import $ from "jquery";
import OffCuffAuthorTab from './OffCuffAuthor';
import commonStore from '../../store/commonStore';
import * as OffCuffActions from '../../actions/offCuffListStateAction';
import { IReducerState, OffCuffTabType, IOffCuffPublicationLibraryData, IOffCuffPublication, IByAllAuthors, IByAuthorData, IOffCuffListState} from '../../states/renditionStates';
import servicesConfig, { IServiceConfig } from '../../services/servicesConfig';
import { RenditionLoadable } from '../../utils/general/LoadableRelated';
import { isAuthPreview, parseToBoolean, base64urlEncode } from '../../utils/general/general';
import CarouselCampaigns from "../rightPartRelated/carouselCampaigns";
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { replaceAll } from '../../utils/general/enterKey';
import services from '../../services/axios-services';
import CarouselEventsOldBranding from '../rightPartRelated/carouselEventsOldBranding';
import CarouselCampaignsOldBranding from '../rightPartRelated/carouselCampaignsOldBranding';
import _ from 'lodash';
import { includes, isEmpty } from 'lodash';
import RenditionUrlGenerator from '../../utils/api/renditionUrlGenerator';
import cvIcon from  '../../../style/img/read_more_new_logo.svg';

const CarouselEvents = RenditionLoadable({
    loader: () => import('../rightPartRelated/carouselEvents'),
}, "carouselEvents OffCuffRightPane", Date.now());

export interface IOffCuffRightPaneProps {
    initialData: any;
    docHeaderJsonData: any;
    currentTabMode: OffCuffTabType;
    offcuffDataMap: IOffCuffListState['offcuffDataMap'];
    byAllAuthors?: IByAllAuthors;
    byAuthor?: IByAuthorData;
    getOffcuffPublicationlibraryData: (params: any, tabType: OffCuffTabType) => any;
    getOffcuffSingleAuthorTopics: (analystId: string, periodicalId?: string) => any;
    getOffcuffAllAuthorsInfo: (periodicalid: string) => any;
    showOldBranding: boolean;
    analystSubscriptionData: any;
    platformIdData: any,
}

const OffCuffTabs = [OffCuffTabType.ByAuthor, OffCuffTabType.ByAllAuthors];

export class OffCuffRightPane extends React.Component<IOffCuffRightPaneProps, any> {
    public EVENTS: any;
    public CAMPAIGNS_DEFAULT: any;
    public CAMPAIGNS: any;
    constructor(props: IOffCuffRightPaneProps) {
        super(props);
        this.EVENTS = React.createRef();
        this.CAMPAIGNS_DEFAULT = React.createRef();
        this.CAMPAIGNS = React.createRef();
        this.requestDefaultPost();
    }

    public getPublicationData(tabType: OffCuffTabType, data?: any) {
        const analystId = this.props.docHeaderJsonData?.authors?.data?.[0]?.analystNumber;
        const params = {
            analystId: tabType === OffCuffTabType.ByAllAuthors ? undefined : analystId,
            periodicalId: this.props.docHeaderJsonData.metadata.periodicalId,
            language: this.props.docHeaderJsonData.metadata.isJP ? 'ja' : 'en',
            ...data,
        };
        return this.props.getOffcuffPublicationlibraryData(params, tabType);
    }

    public checkCurrentCompoentDOMEntit() {
        this.CAMPAIGNS_DEFAULT.current && checkDomEntitlement(this.CAMPAIGNS_DEFAULT.current);
        this.EVENTS.current && checkDomEntitlement(this.EVENTS.current);
        this.CAMPAIGNS.current && checkDomEntitlement(this.CAMPAIGNS.current);
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
        this.getRightPaneData();
    }
    public getAllAuthors() {
        if (!!this.props.byAllAuthors?.allAuthorsName) return;
        this.props.getOffcuffAllAuthorsInfo(this.props.docHeaderJsonData.metadata.periodicalId);
    }

    public getByAuthor() {
        if (!!this.props.byAuthor?.otherTopics) return;
        const analystId = this.props.docHeaderJsonData?.authors?.data?.[0]?.analystNumber;
        analystId && this.props.getOffcuffSingleAuthorTopics(analystId, this.props.docHeaderJsonData.metadata.periodicalId);
    }

    public getTargetDocId(publications: Array<IOffCuffPublication>) {
        return publications.find((post) => post.pubId === window.HTML_RENDITION.initialData.doc_id)?.pubId;
    }

    public getRightPaneData(mode?: OffCuffTabType) {
        const key = mode || this.props.currentTabMode;
        const offCuffData = this.props.offcuffDataMap[key];
        if (offCuffData) {
            const defaultExpandId = this.getTargetDocId(offCuffData.publications);
            commonStore.dispatch(OffCuffActions.expandOffCuffId(defaultExpandId ? [defaultExpandId] : []));
        } else {
            this.getPublicationData(key).then((res?: IOffCuffPublicationLibraryData) => {
                let targetDocId: string | undefined = '';
                if (res?.publications) {
                    targetDocId = this.getTargetDocId(res?.publications);
                }
                commonStore.dispatch(OffCuffActions.expandOffCuffId(targetDocId ? [targetDocId] : []));
            });
        }
        $('html, body').scrollTop(0);
        mode && commonStore.dispatch(OffCuffActions.changeMode(key));
        key === OffCuffTabType.ByAllAuthors ? this.getAllAuthors() : this.getByAuthor();
    }

    public showCampaigns() {
        return !isAuthPreview() && this.props.docHeaderJsonData!.issuerPage!.financialsBlock!.showCampaigns == "true";
    }

    public showEvents() {
        return !isAuthPreview() && parseToBoolean(this.props.docHeaderJsonData?.issuerPage?.financialsBlock?.showEvents);
    }

    public requestDefaultPost() {
        const currentDocId = window.HTML_RENDITION.initialData.doc_id;
        const serviceDetail: IServiceConfig = window.HTML_RENDITION.initialData.encodedStatic ? servicesConfig.GET_DEFAULT_POST_DOC : servicesConfig.GET_POST_DOC;
        const docIdParam = !window.HTML_RENDITION.initialData.encodedStatic ? `doc_id=${currentDocId}` : '';
        const modeStr = replaceAll(
            this.props.currentTabMode.toLocaleLowerCase(),
            ' ',
            '_'
        );
        const activitid = this.props.initialData.vendor_request_id ? `&activitiid=${this.props.initialData.vendor_request_id}` : '';
        serviceDetail.url_parameter = [`${docIdParam}&pureContent=true&currentTab=${modeStr}${activitid}`];
        services.getData(serviceDetail, {}, '')
            .then((res: any) => {
                const type = res.headers['content-type'] == 'application/pdf' ? 'pdf' : 'html';
                const obj: any = {
                    'doc_id': currentDocId,
                    'data': res.data,
                    'type': type
                };
                window.HTML_RENDITION.postDefaultDoc = obj;
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    public render() {
        const { docHeaderJsonData, currentTabMode,analystSubscriptionData , platformIdData } = this.props;
        const authorName = docHeaderJsonData?.authors.data[0].firstName;
        const menuCode = commonStore.getState().commonStateReducer.menuCode;
        const environment = window.HTML_RENDITION.initialData.environment;
        const url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + "/cv2/go/RSCH_LANDING_PAGE/" +base64urlEncode('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/all_research');
        return (
            <div id='off-cuff-rightPane'>
                <Tabs
                    id='off-cuff-rightPane-content'
                    className='off-cuff-rightPane-content'
                    activeKey={currentTabMode}
                    onSelect={(key: OffCuffTabType) => {
                        this.getRightPaneData(key);
                    }}
                    mountOnEnter={true}
                >
                    {OffCuffTabs.map((key) => (
                        <Tab
                            key={key}
                            eventKey={key}
                            unmountOnExit
                            title={
                                key === OffCuffTabType.ByAuthor
                                    ? `By ${authorName || 'Author'}`
                                    : key
                            }
                        >
                            {(!window.HTML_RENDITION.initialData.productCode.includes("GlobalInsights") &&((isEmpty(menuCode) && includes(platformIdData, window.HTML_RENDITION.initialData.platform)) || (menuCode !== "RSCH_LANDING_PAGE" && !isEmpty(menuCode)))) &&
                                    <img className="topRightButton overrideTopRightButton" src={cvIcon} alt="icon" onClick={() => { window.open(url) }}/>

                            }
                            <OffCuffAuthorTab
                                mode={key}
                                authorName={authorName}
                                showOldBranding={this.props.showOldBranding} 
                                analystSubscriptionData={analystSubscriptionData}                            />
                        </Tab>
                    ))}
                </Tabs>

                {/*
                    this.showCampaigns() &&
                    <div id="campaigns_contain" data-entitlement="CAMPAIGNS" ref={this.CAMPAIGNS} tabIndex={0} style={{ display: 'block', backgroundColor: 'white' }}>
                        <div id="campaigns" className="infiniteCarousel">
                            <CarouselCampaigns showDefaultImg={false} />
                        </div>
                    </div>

                */
                }
                {
                /*
                    !this.props.initialData.isStaticHtmlExport && !this.props.initialData.isPublic &&
                    <div id="another_campaigns_contain" ref={this.CAMPAIGNS_DEFAULT} style={{ padding: "15px 0", borderBottom: "1px solid #eee", backgroundColor: 'white' }} data-entitlement="CAMPAIGNS">
                        <div tabIndex={0} id="campaigns_default">
                            <CarouselCampaigns showDefaultImg={true} />
                        </div>
                    </div>
                */
                }
                 {this.props.showOldBranding && this.showCampaigns() &&
                    <div id="campaigns_contain" data-entitlement="CAMPAIGNS" ref={this.CAMPAIGNS} tabIndex={0} style={{ display: 'block', backgroundColor: 'white' }}> {/* After you change carouselCampaigns related code, style={{ display: 'block' }} should remove*/}
                        <div id="campaigns" className="infiniteCarousel">
                            <CarouselCampaignsOldBranding showDefaultImg={false} />
                        </div>
                    </div>
                }
                {this.props.showOldBranding && !this.props.initialData.isStaticHtmlExport && !this.props.initialData.isPublic &&
                    <div id="another_campaigns_contain" ref={this.CAMPAIGNS_DEFAULT} style={{ padding: "15px 0", borderBottom: "1px solid #eee", backgroundColor: 'white' }} data-entitlement="CAMPAIGNS">
                        <div tabIndex={0} id="campaigns_default">
                            <CarouselCampaignsOldBranding showDefaultImg={true} />
                        </div>
                    </div>
                }
                 {!this.props.showOldBranding && !this.props.initialData.isStaticHtmlExport && this.showEvents() &&
                        <div data-entitlement="EVENTS" ref={this.EVENTS} style={{ backgroundColor: 'white' }}>
                            {/* showUncomingEvent judgement inside CarouselEvents.Because it should add a new action and mapToProps, add in here will cause too much component reRender*/}
                            <CarouselEvents showDefaultImg={true}/>
                        </div>
                }
                {this.props.showOldBranding && !this.props.initialData.isStaticHtmlExport && this.showEvents() &&
                        <div data-entitlement="EVENTS" ref={this.EVENTS} style={{ backgroundColor: 'white' }}>
                            {/* showUncomingEvent judgement inside CarouselEvents.Because it should add a new action and mapToProps, add in here will cause too much component reRender*/}
                            <CarouselEventsOldBranding />
                        </div>
                }
            </div>
        );
    }
}
const mapStateToProps = (state: IReducerState) => {
    return {
        initialData: state.asyncStateReducer.initialData,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        currentTabMode: state.offCuffListStateReducer.currentTabMode,
        offcuffDataMap: state.offCuffListStateReducer.offcuffDataMap,
        byAllAuthors: state.offCuffListStateReducer.byAllAuthors,
        byAuthor: state.offCuffListStateReducer.byAuthorData,
        analystSubscriptionData: state.asyncStateReducer.analystSubscriptionData,
        platformIdData: state.asyncStateReducer.platformIdData,

    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        getOffcuffPublicationlibraryData: (params: any, tabType: OffCuffTabType) => dispatch(OffCuffActions.fetchOffCuffPublicationLibrarys(servicesConfig.GET_OFFCUFF_PUBLICATIONS, params, tabType)),
        getOffcuffSingleAuthorTopics: (analystId: string, periodicalid?: string) => dispatch(OffCuffActions.fetchSingleAuthorTopics(analystId, periodicalid)),
        getOffcuffAllAuthorsInfo: (periodicalid: string) => dispatch(OffCuffActions.fetchAllAuthorInfo(periodicalid)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(OffCuffRightPane);
